import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

interface Language {
  code: string;
  name: string;
  flag: string;
}

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const languages: Language[] = [
    { code: "es", name: "Español", flag: "/assets/svg/MX.svg" },
    { code: "en", name: "English", flag: "/assets/svg/US.svg" },
    { code: "ko", name: "한국어", flag: "/assets/svg/KR.svg" },
  ];

  const currentLanguage = languages.find((lang) => lang.code === i18n.language) || languages[1];

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative">
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="bg-transparent border-2 border-[#0B4494] rounded-[24px] px-4 py-2 flex items-center space-x-3 cursor-pointer hover:bg-[#0B4494]/5 transition-colors"
      >
        <img src="/assets/svg/global.svg" alt="Idioma" className="w-5 h-5" />
        <div className="flex items-center space-x-2">
          <span className="text-[#0B4494]">{currentLanguage.name}</span>
        </div>
        <svg
          className={`w-4 h-4 text-[#0B4494] transition-transform ${isOpen ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {isOpen && (
        <div className="absolute top-full mt-2 w-full bg-white border-2 border-[#0B4494] rounded-[24px] shadow-lg overflow-hidden z-50">
          {languages.map((lang) => (
            <div
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`flex items-center space-x-3 px-4 py-3 cursor-pointer hover:bg-[#0B4494]/10 transition-colors ${
                currentLanguage.code === lang.code ? "bg-[#0B4494]/5" : ""
              }`}
            >
              <img src={lang.flag} alt={lang.name} className="w-5 h-5" />
              <span className="text-[#0B4494]">{lang.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
